import React from 'react';
// Import Shared Components
import { VirtualCard, Label } from 'shared-components';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
// Import Component Styles
import { CardInfo, CardDetailsFrame } from './styles';

const SectionOne = ({ page, label, children, iframeUrl, ...props }) => (
  <>
    {iframeUrl ? (
      <CardDetailsFrame
        src={iframeUrl}
        title={label}
        sandbox="allow-scripts allow-same-origin"
      />
    ) : (
      <VirtualCard {...props} />
    )}
    <CardInfo>
      <Label htmlFor="sectionOne">
        <FormattedMessage
          id={`${page}-sectionOne-label`}
          description={`Label for ${label}`}
          defaultMessage={`${label}`}
        />
      </Label>
      {children}
    </CardInfo>
  </>
);

SectionOne.propTypes = {
  children: PropTypes.element.isRequired,
  page: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  iframeUrl: PropTypes.string
};

SectionOne.defaultProps = {
  iframeUrl: null
};

export default SectionOne;
